// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw Online Grabador de Pantalla',
  RecordScreenWithAudio:
    'Graba toda la pantalla, la ventana de aplicación o una pestaña del navegador con audio',
  ScreenOnly: 'Sólo Pantalla',
  ScreenAndCam: 'Pantalla y Cámara Web',
  Microphone: 'Micrófono',
  SystemAudio: 'Audio del Sistema',
  StartRecording: 'Empezar a Grabar',
  NoAudioAndTryAgain:
    'No hay fuente de audio disponible. Por favor, siga las siguientes <1><0>instrucciones</0></1> e inténtelo de nuevo.',
  TheInstruction: 'instrucciones',
  AccessMicrophone:
    'online.hitpaw.es necesita acceder a su Micrófono para grabar audio, por favor haga clic en Permitir.',
  BestScreenRecorderSoftware:
    'Mejor Grabador de Pantalla y Gratuito Software de Transmisión de Video',
  CaptureAnythingOnScreen:
    'Capturar y grabar sus páginas web, conferencias, videollamadas y cualquier en pantalla',
  RecordToShare:
    'Grabar los momentos buenos de sus juegos para compartirlos con sus amigos',
  StreamOnFackbook:
    'Transmitir en Facebook, YouTube, Twitch, etc. como un Profesional',
  BringMagic:
    'Llevar la cámara web virtual mágica a la transmisión en directo y al videochat',
  StepOne: 'Paso 1: Selecciona la pantalla que desea grabar.',
  StepTwo: 'Paso 2: Selecciona la pantalla que desea grabar.',
  StepThree: "Paso 3: Haz clic en 'Compartir el audio del sistema'.",
  StepFour: "Paso 2: Haz clic en 'Compartir' y empeza a grabar.",
  GrantPermission:
    'Por favor, concede el permiso de grabación de pantalla e inténtalo de nuevo.',
  RecordingProgress: 'Grabando ahora...',
  MoreOptions: 'Más Opciones de Grabación:',
  Pause: 'Pausar',
  Continue: 'Continuar',
  Stop: 'Detener',
  Webcam: 'Cámara Web',
  GreenScreenAndChangeBackground: 'Pantalla Verde y Cambiar Fondo',
  StreamToYouTube: 'Transmitir en Facebook, Twitch, YouTube, etc.',
  ScheduleRecording: 'Grabación Temporizada',
  NewRecording: 'Nueva Grabación',
  ExportToMp4: 'Exportar a MP4',
  AddWatermark: 'Añadir Marca de Agua',
  ChangeSpeed: 'Cambiar Velocidad',
  CutAndTrim: 'Cortar y Recortar',
  '120XDownload':
    '120X velocidad más rápida convertidor de video y descargador de video HD',
  CovertAudioFormats:
    'Convertir los archivos de video y audio a 1,000+ formatos',
  DownloadVideoFromWebsites:
    'Descargar y guardar videos de 10,000+ sitios web compartidos',
  BatchConvertImageAndGif: 'Convertir imágenes y crear GIFs de video por lotes',
  RichEdingingFeatures:
    'Abundantes funciones de edción incorporadas: unir, cortar, recortar, marca de agua, etc.',
  BestVideoEditor: 'El mejor editor de video diseñado para funciones múltiples',
  MakeSimpleEdits:
    'Un editor de video galardonado que facilita la edición compleja.',
  BeyondImaginationMaterials:
    'Varios materiales incorporados y en línea más allá de la imaginación.',
  AqualityVideoMaker:
    'Un calidad-dirigida programa de video que puede exportar y exportar videos 1080P/4K gratis completamente.',
  WorkOnAnywhere:
    'Se ejecuta con seguridad en cualquier PC sin afectar su función.',
  RecordCompleted: 'Grabar con éxito',
  YouMayNeed: 'Podría Necesitar',
  Download: 'Descargar',
  TryItFree: 'Pruébalo Gratis',
  AlreadyHaveAccount: '¿Ya tienes una cuenta?',
  LoginNow: 'Iniciar sesión ahora',
  exceedTenMin: 'La grabación ya ha llegado a 10 minutos.',
  UpgradeToRecord: 'Actualizar para continuar grabando.',
  ScreenProFeature: 'HitPaw Online Grabador de Pantalla Pro.',
  FreeScreenAccount:
    'La cuenta gratuita tiene solo <1><0>10</0></1> minutos de tiempo de grabación.',
  BuyNow: 'Comprar ahora',
  DownloadMp4: 'Descargar en MP4',
  FreeDownload: 'Descargar Gratis',
  DownloadTenMin: 'Descargar 10 minutos',
  FullVideo: 'Video Completo',
  FormatMp4: 'Formato como MP4',
  Downloading: 'Descargando ...',
  DownloadFailed: 'Ha fallado la descarga, por favor intente de nuevo.',
  DownloadSuccess: '¡Descargar con éxito!',
  Exceed100MDownloadConvert:
    'El tamaño del video no debe superar los 100 MB para descargar video en formato MP4. Descargar HitPaw Video Converter para obtener más funciones.',
  Exceed30Min:
    'La duración del video no debe superar los 30 minutos para descargar video en formato MP4. Descargar HitPaw Video Converter para obtener más funciones.',
  Week: 'Semanalmente',
  Month: 'Mensualmente',
  Year: 'Anualmente',
  BilledMonthly: 'Mensualmente',
  BilledAnnually: 'Pagado Anualmente',
  ConvertText1:
    'Descargar la Versión de Escritorio para Procesar los Archivos Grandes SIN Limitación de Tamaño Por Lotes',
  ConvertText2:
    'Convertir por lotes los archivos de video y audio a más de 1,000 formatos a una velocidad 120 veces superior',
  ConvertText3:
    'Descargar y guardar videos de 10,000+ sitios web como YouTube, TikTok, Instagram, etc.',
  ConvertText4:
    'Convertir Apple Music a MP3 sin DRM (Sólo la versión para Windows)',
  TenMinUp: 'La grabación ya ha llegado a 10 minutos.',
  UpgradeMore: 'Actualizar para continuar grabando.',
  NoRecordLimit: 'Grabar video sin limitación de tiempo',
  NoRecordNumLimit: 'Grabar video sin limitación de número',
  DownloadVideoMP4: 'Descargar Video en MP4',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: 'Actualización inmediata',
  CheckConnect: 'Compruebe su conexión e inténtelo de nuevo.',
};
